import React, { useState } from "react";
import "../css/contactus.scss";
import { STORE_CONFIG } from "../config/storeConfig";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const update = (event) => setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  const submit = (event) => {
    event.preventDefault();
    const subject = encodeURIComponent(`Store enquiry from ${form.name}`);
    const body = encodeURIComponent(`Reply to: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:${STORE_CONFIG.supportEmail}?subject=${subject}&body=${body}`;
  };
  return (
    <main className="contact-page main"><div className="contact-container">
      <header className="contact-header"><p className="eyebrow">Customer care</p><h1>CONTACT</h1><p>Questions about a product or order are welcome. Please do not include full card details, passwords or unnecessary identity documents.</p></header>
      <div className="contact-layout">
        <section className="contact-details"><h2>Email us</h2><a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a><p>Operating region: {STORE_CONFIG.operatingRegion}</p><p>Messages are reviewed in the configured {STORE_CONFIG.timezone} time zone. No telephone number or public shop address is confirmed.</p></section>
        <form className="contact-form" onSubmit={submit}>
          <label htmlFor="contact-name">Name</label><input id="contact-name" name="name" value={form.name} onChange={update} required autoComplete="name" />
          <label htmlFor="contact-email">Email</label><input id="contact-email" name="email" type="email" value={form.email} onChange={update} required autoComplete="email" />
          <label htmlFor="contact-message">Message</label><textarea id="contact-message" name="message" rows="7" value={form.message} onChange={update} required />
          <button type="submit">OPEN EMAIL MESSAGE</button>
        </form>
      </div>
    </div></main>
  );
}

export default Contact;

